import { t } from "../i18n/index";

export function parse26004Frame(packet) {
    console.log("process frame", packet)

    let items = [];

    let addHead = function (content) {
        items.push(`<span class="item item-head">[${content}]</span>`);
    }

    let addItem = function (key, value) {
        items.push(`<span class="item">${key}: ${value}</span>`);
    }

    let frame = packet['frame']
    if (!frame) {
        addHead(t(/*非法数据包*/'frame.illegal_data_packet'));
    }



    let parsePayload = function (p) {
        const frameKeyNaming = {
            'vcu_version': t(/*VCU版本*/'device.vcu_version'),

            'iccid': 'ICCID',

            'bms_id': 'BMS ID',
            'bms_version': t(/*BMS版本*/'device.vcu_version'),

            'ota_result': t(/*OTA结果*/'device.ota_result'),
            'ota_version': t(/*OTA版本*/'device.ota_version'),
            'ota_id': 'OTA ID',

            'gsm_signal_strength': t(/*GSM信号强度*/'device.gsm_signal_strength'),

            'location_status': t(/*定位状态*/'device.location_status'),
            'location_north_south': t(/*南北半球*/'device.location_north_south'),
            'location_east_west': t(/*东西半球*/'device.location_east_west'),
            'location_longitude': t(/*经度*/'device.location_longitude'),
            'location_latitude': t(/*纬度*/'device.location_latitude'),
            'location_speed': t(/*定位速度*/'device.location_speed'),
            'location_angle': t(/*定位角度*/'device.location_angle'),
            'location_satellite_count': t(/*卫星个数*/'device.location_satellite_count'),

            'lock_status': t(/*锁状态*/'device.lock_status'),

            'mileage': t(/*上锁后行驶里程*/'device.mileage_curr'),
            'max_speed': t(/*上锁后最高时速*/'device.max_speed'),

            'battery_status': t(/*充电状态*/'device.battery_status'),
            'vcu_soc': t(/*VCU电量*/'device.vcu_soc'),
            'battery_soc': t(/*电池电量*/'device.battery_soc'),
            'mileage_endurance': t(/*续航里程*/'device.mileage_endurance'),
            'battery_temperature': t(/*电池温度*/'device.battery_temperature'),
            'battery_cycle_count': t(/*循环次数*/'device.battery_cycle_count'),
            'battery_charge_remaining_time': t(/*充电剩余时长*/'device.battery_charge_remaining_time'),

            'guard_alarm_status': t(/*防盗报警状态*/'device.guard_alarm_status'),

            'warning': t(/*异常信息*/'device.warning'),

            'lock_result': t(/*锁车状态*/'device.lock_result'),

            'bms_config_set_result': t(/*BMS参数设置反馈*/'device.bms_config_set_result'),

            'check_vcu_mode': t(/*检测-VCU工作模式*/'device.check_vcu_mode'),
            'check_vcu_error': t(/*检测-VCU故障*/'device.check_vcu_error'),
            'check_mcu_mode': t(/*检测-MCU模式*/'device.check_mcu_mode'),
            'check_mcu_error': t(/*检测-MCU故障*/'device.check_mcu_error'),
            'check_bms_1_mode': t(/*检测-BMS1模式*/'device.check_bms_1_mode'),
            'check_bms_1_error': t(/*检测- BMS1故障*/'device.check_bms_1_error'),
            'check_bms_2_mode': t(/*检测-BMS2模式*/'device.check_bms_2_mode'),
            'check_bms_2_error': t(/*检测-BMS2故障*/'device.check_bms_2_error'),
            'check_hmi_mode': t(/*检测-HMI模式*/'device.check_hmi_mode'),
            'check_bc_error': t(/*检测-BC故障*/'device.check_bc_error'),

            'heartbeat_interval': t(/*心跳周期*/'device.heartbeat_interval'),

            'apn': 'APN',

            'server_addr': t(/*服务器地址*/'device.server_addr'),

            'locate_interval_acc_on': t(/*ACC ON 定位上报周期*/'device.locate_interval_acc_on'),
            'locate_interval_acc_off': t(/*ACC OFF定位上报周期*/'device.locate_interval_acc_off'),
        };

        for (let key in p) {
            let value = p[key];
            let name = frameKeyNaming[key] || '';
            if (!name) {
                continue
            }
            addItem(name, value)
        }
    }

    let type = frame['type'] || 0;
    switch (type) {
        case 1: {
            addHead(t(/*认证*/'frame.type.authentication'));

        } break;

        case 2: {
            addHead(t(/*请求入网*/'frame.type.request_access'));
        } break;

        case 3: {
            addHead(t(/*请求更新SessionKey*/'frame.type.request_update_session_key'));
        } break;

        case 4: {
            addHead(t(/*上行数据*/'frame.type.up_link_data'));

            let payload = frame['data']
            if (payload) {
                parsePayload(payload)
            }

        } break;

        case 5: {
            addHead(t(/*心跳*/'frame.type.heartbeat'));
        } break;

        case 8: {
            addHead(t(/*上报固件版本号*/'frame.type.report_fota_version'));
        } break;

        case 9: {
            addHead(t(/*回复OTA升级任务*/'frame.type.response_ota_task'));
        } break;

        case 10: {
            addHead(t(/*请求下载固件数据*/'frame.type.request_down_fota_data'));
        } break;

        case 12: {
            addHead(t(/*升级结果通知*/'frame.type.notification_upgrade_result'));
        } break;
    }

    return items.join(' ');
}